import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './NavbarBrand.css';

const propTypes = {
  active: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  id: PropTypes.string,
};

const defaultProps = {
  active: false,
  children: undefined,
  className: undefined,
  href: undefined,
  icon: undefined,
  id: 'desktop-logo', // Used by automated test team to find logo
  tag: 'a',
};

const NavbarBrand = ({
  active,
  children,
  className,
  icon,
  tag: Tag,
  id,
  ...other
}) => {
  const classes = classNames(
    className,
    'apollo-navbar-brand',
    active ? 'apollo-active' : '',
  );

  if (icon) {
    return (
      <Tag {...other} className={classes}>
        <img id={id} alt="Missing" height="40" src={icon} /> {children}
      </Tag>
    );
  }

  return (
    <Tag {...other} className={classes}>
      {children}
    </Tag>
  );
};

NavbarBrand.propTypes = propTypes;
NavbarBrand.defaultProps = defaultProps;

export default NavbarBrand;
